export default "__VITE_PUBLIC_ASSET__59559936__"